import * as React from "react";
import { Alert, Snackbar } from "@mui/material";

export default function AppSnackbar({
  open,
  message,
  severity = "success",
  onClose,
  autoHideDuration = 3500,
}) {
  return (
    <Snackbar
      open={open}
      autoHideDuration={autoHideDuration}
      onClose={onClose}
      anchorOrigin={{ vertical: "top", horizontal: "center" }}
    >
      <Alert
        onClose={onClose}
        severity={severity}
        variant="filled"
        sx={{
          minWidth: { xs: 280, sm: 360 },
          borderRadius: 2,
          boxShadow: "0 12px 32px rgba(15, 23, 42, 0.22)",
          fontWeight: 600,
        }}
      >
        {message}
      </Alert>
    </Snackbar>
  );
}
